import { action } from 'easy-peasy';
import { IActionSetQuickNotes } from '../types';

const setQuickNotes: IActionSetQuickNotes = action((state, quickNotes) => {
  state.info.quickNotes = quickNotes;
});

export default setQuickNotes;
